import { store } from '../store';
import { exceptions_email } from '../config/exceptions';   
//import moment from 'moment';
export const AUTH = (to, from , next) =>
{
    if(/* store.state.auth.token &&  */store.state.auth.user)
    {
        return next();
    }
    else
    {
        let endpoint_url = `/${store.state.locale}/signin`;
        if(to)
        {
            let q = '';
            let path = to.path.split("/");
            path.forEach( (p) => 
            {
                if(p.length > 0)
                {
                    q = q+`${p}~`;
                }
            });
            q = q.substring(0, q.length - 1);
            endpoint_url = `${endpoint_url}?to=${q}`;
        }
        return next(endpoint_url);
    }

};
export const GUEST = (to, from, next) => 
{
    if(!store.state.auth.user)
    {
        next();
    }
    else
    {
        let endpoint_url = `/${store.state.locale}/dashboard`;
        return next(endpoint_url);
    }
};
/**
 * ZDHC Gateway 2.0 gate: the legacy "do you have keys?" check becomes
 * "is your supplier linked to our SP account?". The association is set
 * by an admin on the backend (users.supplier_reference_id).
 */
export const HAS_SUPPLIER_LINK = (to, from , next) =>
{
    if(store.state.auth.user && store.state.auth.user.supplier_reference_id)
    {
        return next();
    }
    else
    {
        let endpoint_url = `/${store.state.locale}/waiting-page`;
        if(to)
        {
            let q = '';
            let path = to.path.split("/");
            path.forEach( (p) =>
            {
                if(p.length > 0)
                {
                    q = q+`${p}~`;
                }
            });
            q = q.substring(0, q.length - 1);
            endpoint_url = `${endpoint_url}?to=${q}`;
        }
        return next(endpoint_url);
    }

};
export const HAS_ACTIVE_SUBSCRIPTION = (to, from , next) =>
{
    if((store.state.auth.user && store.state.auth.user.active_subscription) 
        || exceptions_email.includes(store.state.auth.user.email.toLowerCase())
        || store.state.auth.user.in_exception)
    {
        return next();
        
    }
    let endpoint_url = `/${store.state.locale}/waiting-page`;
    if(to)
    {
        let q = '';
        let path = to.path.split("/");
        path.forEach( (p) => 
        {
            if(p.length > 0)
            {
                q = q+`${p}~`;
            }
        });
        q = q.substring(0, q.length - 1);
        endpoint_url = `${endpoint_url}?to=${q}`;
    }
    return next(endpoint_url);

};